import { create } from 'zustand';
import { StudentData, MacroData } from '../types';

interface AppState {
  apiKey: string | null;
  apiUrl: string | null;
  apiModel: string | null;
  taskId: string | null;
  className: string | null;
  studentDataList: StudentData[];
  macroData: MacroData | null;
  isLoading: boolean;
  error: string | null;
  diagnosisReport: string | null;

  setApiKey: (key: string) => void;
  setApiUrl: (url: string) => void;
  setApiModel: (model: string) => void;
  setTaskId: (taskId: string) => void;
  setClassName: (className: string) => void;
  setStudentDataList: (data: StudentData[]) => void;
  setMacroData: (data: MacroData) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setDiagnosisReport: (report: string | null) => void;
  reset: () => void;
}

const initialState = {
  apiKey: null,
  apiUrl: null,
  apiModel: null,
  taskId: null,
  className: null,
  studentDataList: [],
  macroData: null,
  isLoading: false,
  error: null,
  diagnosisReport: null,
};

export const useStore = create<AppState>((set) => ({
  ...initialState,

  setApiKey: (key) => set({ apiKey: key }),
  setApiUrl: (url) => set({ apiUrl: url }),
  setApiModel: (model) => set({ apiModel: model }),
  setTaskId: (taskId) => set({ taskId }),
  setClassName: (className) => set({ className }),
  setStudentDataList: (data) => set({ studentDataList: data }),
  setMacroData: (data) => set({ macroData: data }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  setDiagnosisReport: (report) => set({ diagnosisReport: report }),
  reset: () => set(initialState),
}));